import { Box, Container } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import { CreateCSSProperties, createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { withGlobalNotifications } from '@/layout/hocs';
import { makeSelectIsMobileView, makeSelectVHSize } from '@/model/global/selectors';
import { container } from '@/utils/ui';

const useStyles = makeStyles((theme: Theme) => {
  const mainBoxContainer: CreateCSSProperties = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: container.minMobileWidth,
  };
  const mainContainer: CreateCSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    marginTop: 0,
    marginBottom: 0,
    padding: 0,
    position: 'relative',
  };

  return createStyles({
    mainBoxMobileContainer: mainBoxContainer,
    mainBoxContainer: {
      ...mainBoxContainer,
      paddingTop: theme.spacing(8),
    },
    mainContainer: {
      ...mainContainer,
      ...theme.MainContainer,
      borderRadius: '12px',
    },
    mainMobileContainer: {
      ...mainContainer,
      flexGrow: 1,
      maxWidth: 'unset',
    },
  });
});

export interface BaseContainerProps {
  height?: number | 'unset';
  minHeight?: number | 'unset';
  width?: number | 'unset';
  containerClassname?: string;
  boxClassname?: string;
  containerPrefix?: ReactNode;
  children: NonNullable<React.ReactNode>;
}

const selectIsMobile = makeSelectIsMobileView();
const selectVHSize = makeSelectVHSize();

export const BaseContainer: React.FC<BaseContainerProps> = ({
  containerPrefix,
  containerClassname,
  boxClassname,
  children,
  height,
  minHeight,
  width,
}: BaseContainerProps) => {
  const classes = useStyles();
  const isMobile = useSelector(selectIsMobile);
  const vh = useSelector(selectVHSize);

  return (
    <Box
      {...(width && !isMobile ? { style: { width } } : { style: { maxWidth: width } })}
      minHeight={{ minHeight }}
      height={vh ? `${vh * 100}px` : '100vh'}
      className={clsx(isMobile ? classes.mainBoxMobileContainer : classes.mainBoxContainer, containerClassname)}
    >
      {containerPrefix}
      <Container
        fixed
        maxWidth="xs"
        className={clsx(isMobile ? classes.mainMobileContainer : classes.mainContainer, boxClassname)}
        {...(height ? { style: { height } } : {})}
      >
        {children}
      </Container>
    </Box>
  );
};

export default withGlobalNotifications(BaseContainer);
